var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-page"},[_c('FocusedDashboardShell',{attrs:{"goal-id":_vm.goalId,"is-dark":_vm.theme === _vm.THEMES.DARK}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }